module.exports = __webpack_public_path__ + "static/media/blueBag.889e9291.svg";